import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import { useLocation } from 'react-router-dom'

import { useUser } from '@/stores/slices/user-slice.ts'
import { CONTENT_WIDTH, DASHBOARD_MENU, WIDTH_NAVIGATION_PANEL_IN_PIXEL } from '@/constants.ts'
import { acqFolder, NavigationFolder, sbpFolder } from '@/layouts/dashboard/navigation-panel/navigation-folder.tsx'

export const withNavigationPanel = <P extends object>(Component: FC<P>) => {
  const Wrapped = (props: P) => {
    const user = useUser()
    const location = useLocation()

    if (!user?.id) return null

    const userMenu = DASHBOARD_MENU(user.permissions)
    const activeMenu = userMenu.find((menu) => location.pathname.includes(menu.href))

    return (
      <Stack
        direction="row"
        sx={{ display: 'flex', width: '100vw', height: 'calc(100vh - 64px)', backgroundColor: 'background.footer' }}
      >
        <Stack
          component={'nav'}
          direction="column"
          sx={{
            overflowY: 'auto',
            padding: '40px 10px',
            minWidth: `${WIDTH_NAVIGATION_PANEL_IN_PIXEL}px`,
            height: '100%',
            gap: '40px',
          }}
        >
          {/*Пока указаываем явно какие разделы выделяем*/}
          <NavigationFolder titleFolder={'СБП'} permissionsKey={sbpFolder} />
          <NavigationFolder titleFolder={'Эквайринг'} permissionsKey={acqFolder} />
        </Stack>
        <Box
          sx={{
            width: `calc(100vw - ${WIDTH_NAVIGATION_PANEL_IN_PIXEL}px)`,
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            alignItems: 'center',
            overflowY: 'auto',
            minHeight: '100%',
            padding: '40px 0 66px 0',
            borderBottomLeftRadius: '16px',
            borderTopLeftRadius: '16px',
            bgcolor: 'background.default',
          }}
        >
          <Typography variant="h3" color="text.primary" sx={{ px: 2, width: '100%', maxWidth: CONTENT_WIDTH }}>
            {activeMenu?.title}
          </Typography>
          <Component {...props} />
        </Box>
      </Stack>
    )
  }
  Wrapped.displayName = `withNavigationPanel(${Component.displayName ?? Component.name})`
  return Wrapped
}
